import { optionalToJS } from './utils';

const userReportsId = (state, id) => {
  if (state.userReports.ids.includes(id)) {
    return state.entities.getIn(['userReports', id.toString()]);
  }
};

export const getUserReport = (state, id) => {
  if (state.entities.getIn(['userReports']) && state.userReports) {
    return optionalToJS(userReportsId(state, id));
  }
};

const userReportsIds = (state, ids) => ids.map(id => userReportsId(state, id));

const userReportsAll = (state) => userReportsIds(state, state.userReports.ids);

export const getUserReportsAll = (state) => userReportsAll(state).toJS();

const userReportsmatchesQuery = (report, query) =>
  report.get("username").toLowerCase().includes(query) ||
  report.get("activity").toLowerCase().includes(query);

const reportFilterFunction = (query, tags) => (report) =>
userReportsmatchesQuery(report, query)


const filteredReportsByQuery = (state, query) => {
  let filteredReports= userReportsAll(state);
  query = query.trim().toLowerCase();

  if (query !== "" ) {
    filteredReports = filteredReports.filter(
      reportFilterFunction(query)
    );
  }

  return filteredReports;
};

const filteredPReports = (state, query) => {
  return filteredReportsByQuery(state, query);
};
export const getUserReportFilterbyQuery = (state, query) => filteredPReports(state, query).toJS();

export const isFetchingtUserReports = (state) => state.userReports.isFetching;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/selectors/user_reports.js